const RelatedModel = require('module/user/related_model')

const PortfolioItem = RelatedModel.extend({

    defaults: {
        type: '',
        url: '',
        title: '',
        desc: '',
        width: null,
        height: null,
        video_id: '',
        video_thumbnail: '',
    },

})

module.exports = PortfolioItem
